<template>
  <v-app align-center justify-center>
    <v-content>
      <v-container
        fluid
        justify-center
        fill-height
        align-center
        class="primary"
      >
        <v-layout align-center column>
          <v-layout
            shrink
            rounded
            align-center
            justify-center
            class="pa-2 my-6 white"
          >
            <a href="https://app.stintau.com/">
              <v-img
                :src="require('@/assets/images/logo.png')"
                width="144px"
                height="144px"
              ></v-img>
            </a>
          </v-layout>
          <div class="display-1 ma-3">
            <a
              href="https://app.stintau.com"
              class="white--text text-decoration--none"
              >Stint</a
            >
          </div>

          <v-card max-width="1300" width="900" class="mx-auto mt-10 pa-10">
            <h1 class="text-center mb-8">Privacy</h1>
            <div v-html="content"></div>

            <v-progress-linear
              v-if="isLoading"
              color="primary accent-4"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
          </v-card>

          <ul class="links">
            <li>
              <a href="https://cms.develop.stintau.com/privacy-policy">
                Privacy Policy
              </a>
            </li>
            <li>
              <a href="https://cms.develop.stintau.com/terms-of-service">
                Terms and Conditions
              </a>
            </li>
            <li>
              <a href="https://cms.develop.stintau.com/support">
                Support
              </a>
            </li>
          </ul>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import get from 'lodash/get'

export default {
  data() {
    return {
      content: '',
      isLoading: false
    }
  },

  mounted() {
    this.getTerms()
  },

  methods: {
    async getTerms() {
      try {
        this.isLoading = true
        const response = await this.$api.get(`pages/privacy`)
        this.content = get(response, 'data')
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.links {
  list-style: none;
  display: flex;
  width: 500px;
  justify-content: space-between;
  margin-top: 4rem;

  a {
    color: white;
  }
}
</style>
